export default __webpack_public_path__ + "static/media/arrowR.050a6062.png";